// 0-127 are standard ASCII values
// cp437Table only has values from 128-255 below
const cp437Table =
  "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "; // no itx

export function encodeToCP437(input: string): any {
  if (typeof input !== "string") {
    throw new TypeError("Input must be string"); // no itx
  }

  let output: any = [];
  for (let i = 0; i < input.length; i++) {
    const charCode = input.charCodeAt(i);
    if (charCode < 128) {
      output.push(charCode); // ASCII
    } else {
      const index = cp437Table.indexOf(input[i]); // Umlaut
      if (index !== -1) {
        output.push(index + 128);
      } else {
        throw new Error(`Character "${input[i]}" not found in CP437 table.`);
      }
    }
  }

  return new Uint8Array(output);
}

export function decodeFromCP437(input: string[] | Uint8Array | Buffer) {
  if (!(input instanceof Uint8Array)) {
    throw new TypeError("Input must be Uint8Array"); // no itx
  }

  let output = "";
  for (let i = 0; i < input.length; i++) {
    const byte = input[i];
    if (byte < 128) {
      output += String.fromCharCode(byte); // ASCII
    } else {
      output += cp437Table[byte - 128]; // Umlaut
    }
  }
  return output;
}

// For Testing purpose only
// export function compareEncodings() {
//   var iconv = require("iconv-lite");
//   var iconvE = iconv.encode("Kanäle", "CP437");
//   var iconvD = iconv.decode(iconvE, "CP437");

//   console.log(iconvE);
//   console.log(iconvD);

//   var customE = encodeToCP437("Kanäle");
//   var customD = decodeFromCP437(customE);

//   console.log(customE);
//   console.log(customD);
// }
